import ItemCardClickableProperty from '../generic/ItemRowCardClickableProperty'
import {ROUTES} from '../../../../../constants/routing'
import React, {memo} from 'react'
import {useDatxPathGenerator} from '../../../../../util/routing'
import {ItemOrganization} from '../../../../../item/model/ItemOrganization'

const ItemDefinedBy = ({definedByOrganization}: {definedByOrganization: ItemOrganization}) => {
    const generatePath = useDatxPathGenerator()

    return <ItemCardClickableProperty value={definedByOrganization?.label}
                               linkTo={generatePath(ROUTES.organizationDetails.path, {organizationId : definedByOrganization.id})}
                               testId={`link-${definedByOrganization.id}-organization`}
                               opensInNewTab={true}
    />
}

export const ItemDefinedByComponent = memo(ItemDefinedBy)